var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-scroll-view',{staticClass:"with-footer login-layout",style:(_vm.backgroundStyle),attrs:{"height":"100%","width":"100%"}},[_c('div',{staticClass:"dx-card"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }